export class ReverterPerdaContasReceberRequest {
    public idContasReceberParcela: number = 0;
}
